import React from 'react';

import FootballTeamContent from '../../molecules/football-team-content/football-team-content';
import PlayerCard, { IPlayerCard } from '../../molecules/player-card/player-card';
import SubsitutePlayersCard from '../../molecules/substitute-players-card/substitute-players-card';
import { ISubstitutePlayer } from '../../atoms/substitute-player/substitute-player';
import { ISubstituteTrainer } from '../../atoms/substitute-trainer/substitute-trainer';
import { makeClassNames } from '../../../utils/styles';
import { playerCardtypes } from '../../../typings/player';
import CardAdv from '../../atoms/card-adv/card-adv';

import './football-team.scss';

type Player = Omit<IPlayerCard, 'playerTeamImageUrl' | 'playerTeamName' | 'playerTeamColor'>;
type SubstitutePlayer = ISubstitutePlayer;
type Trainer = ISubstituteTrainer;

export interface ITeamContent {
  title: string;
  text: string;
}
export interface IFootballTeam {
  type: playerCardtypes;
  players: Player[];
  substitutePlayers?: SubstitutePlayer[];
  trainer?: Trainer;
  teamName: string;
  teamColor: string;
  teamImageUrl: string;
  teamContent?: ITeamContent[];
}

const classNames = () =>
  makeClassNames({
    footballTeam: 'football-team',
    players: 'football-team__players',
    playerWrapper: 'football-team__player-wrapper',
    advMPU: 'football-team__adv-mpu',
    advNative: 'football-team__adv-native',
    paragraph: ['text', 'text--color-blue', 'text--font-size-16', 'text--weight-400'],
    advertising: 'c-label--advertisement',
  });

const isAdvMpu = (index: number): boolean => [1, 3, 5, 9].includes(index);
const isAdvNative = (index: number): boolean => [7].includes(index);

const cn = classNames();

const AdvFake = (props: { imageUrl: string }) => {
  const { imageUrl } = props;

  return (
    <>
      <div
        style={{
          color: '#414141',
          fontSize: '.72222rem',
          lineHeight: '100%',
          margin: '.38889rem 0',
          textAlign: 'center',
          textTransform: 'uppercase',
        }}
      >
        pubblicità
      </div>
      <div>
        <div
          style={{
            width: '100%',
            height: '100%',
            zIndex: '-999',
            top: '0px',
            left: '0px',
          }}
        >
          <img src={imageUrl} alt="Advertisement" style={{ display: 'block' }} />
        </div>
      </div>
    </>
  );
};

const FootballTeam = (props: IFootballTeam) => {
  const { type, players, substitutePlayers, teamName, teamColor, teamImageUrl, trainer, teamContent } = props;

  return (
    <div className={cn.footballTeam}>
      <div className={cn.players}>
        {players?.map((player, index) => (
          <div key={`player-${index}`} className={cn.playerWrapper}>
            <PlayerCard
              type={type}
              imageUrl={player.imageUrl}
              lastName={player.lastName}
              firstName={player.firstName}
              playerUrl={player.playerUrl}
              mvp={player.mvp}
              playerTeamImageUrl={teamImageUrl}
              playerTeamName={teamName}
              playerTeamColor={teamColor}
              playerPoints={player.playerPoints}
              playerTeamShowPoints={player.playerTeamShowPoints}
              playerTeamRole={player.playerTeamRole}
              // eslint-disable-next-line no-nested-ternary
              label={type === playerCardtypes.PAGELLE ? 'voto' : type === playerCardtypes.MARCATORI ? 'gol' : ''}
            />
            {isAdvMpu(index) && (
              <div key={`advMPU-${index}`} className={cn.advMPU}>
                <CardAdv shiftingContent fakeAdvs />
              </div>
            )}
            {isAdvNative(index) && (
              <div key={`advNative-${index}`} className={cn.advNative}>
                <AdvFake imageUrl="https://placehold.co/420x200" />
              </div>
            )}
          </div>
        ))}
        {substitutePlayers && trainer ? (
          <SubsitutePlayersCard
            type={type}
            title="I subentrati"
            players={substitutePlayers}
            playerTeamColor={teamColor}
            trainer={trainer}
          />
        ) : null}
        {teamContent?.map((content, index) => (
          <FootballTeamContent key={`content-${index}`} playerTeamColor="#1F1F1F">
            <h3>{content.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: content.text }} />
          </FootballTeamContent>
        ))}
      </div>
    </div>
  );
};

export default FootballTeam;
